import { useCallback, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { handleToast } from "../../../utils/functions";

import client from "../../client";
import handleApiError from "../../../hooks/handleApiError";

export default function useUploadStudentToClass() {
  const navigate = useNavigate();
  const { classId, schoolId } = useParams();
  const [loading, setLoading] = useState(false);

  const request = useCallback(
    async (payload) => {
      setLoading(true);

      try {
        const res = await client.post(
          `/classes/${classId}/students/multiple`,
          payload
        );

        setLoading(false);

        if (res.data?.statusCode === "00") {
          handleToast(res.data?.message, "warning");
          return navigate(`/${schoolId}/settings/billing`);
        }

        handleToast(res.data?.message);
        if (res.data?.success) navigate(`/${schoolId}/classes/${classId}`);
      } catch (error) {
        setLoading(false);
        handleApiError(error);
      }
    },
    [classId, schoolId, navigate]
  );

  return { request, loading };
}
